import type { ColumnFiltersState } from '@tanstack/react-table';
import type { DevelopmentPaceScenarioParams } from './atoms';
import type { PaceModel } from './types';

export const DEFAULT_PARAMS: DevelopmentPaceScenarioParams = {
  page: 1,
  pageSize: 100,
  sortAttribute: 'created_at',
  sortDirection: 'DESC',
};

export const PACE_MODEL_LABELS: Record<PaceModel, string> = {
  years_to_full_development: 'Years to Full Development',
  fixed_rate: 'Fixed Rate',
};

export const SORT_FIELD_MAP: Record<string, string> = {
  name: 'name',
  paceModel: 'pace_model',
  createdAt: 'created_at',
  updatedAt: 'updated_at',
};

export const columnFiltersToParams = (
  filters: ColumnFiltersState
): Partial<DevelopmentPaceScenarioParams> => {
  const params: Partial<DevelopmentPaceScenarioParams> = {
    paceModel: undefined,
    createdBy: undefined,
    createdAt: undefined,
    updatedAt: undefined,
  };

  for (const filter of filters) {
    switch (filter.id) {
      case 'paceModel':
        params.paceModel = filter.value as string[];
        break;
      case 'createdBy':
        params.createdBy = filter.value as string[];
        break;
      case 'createdAt': {
        const [start, end] =
          (filter.value as [string | null, string | null]) ?? [];
        params.createdAt =
          start || end
            ? { start: start ?? undefined, end: end ?? undefined }
            : undefined;
        break;
      }
      case 'updatedAt': {
        const [start, end] =
          (filter.value as [string | null, string | null]) ?? [];
        params.updatedAt =
          start || end
            ? { start: start ?? undefined, end: end ?? undefined }
            : undefined;
        break;
      }
    }
  }

  return params;
};
